export default "static/media/githubio.7f736e7.svg"